export default __webpack_public_path__ + "static/media/remuneracao.a60feb1c.svg";